import React, { useEffect } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from 'app/routes';
import { useContext as useUsersContext } from 'components/Users/Context';

import ErrorBoundary from 'components/new_ui/Errors/ErrorBoundary';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import ListView from './Pages/Index/Index';
import AddView from './Pages/Create/Index';
import SuccessImport from './Pages/SuccessImport/Index';

export default function Index() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUser } = useUsersContext();

  const router = createBrowserRouter([
    {
      path: routes.managers.coaches.index,
      element: <ListView />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: routes.managers.coaches.add,
      element: <AddView />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: routes.managers.coaches.successImport,
      element: <SuccessImport />,
      errorElement: <ErrorBoundary />,
    },
  ]);

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUser.user === null) {
    return (
      <div className="content onboarding-content p-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return (
    <RouterProvider router={router} />
  );
}
